import React from "react";
import DashboardMain from "components/Signagedashboard/DashboardMain";

const SignageTeammemberDashboard = () => {
  // Use signageteammember base route
  const baseRoute = '/signageteammember';
  
  return <DashboardMain baseRoute={baseRoute} />;
}

export default SignageTeammemberDashboard;